export default __webpack_public_path__ + "80498c88277706f3f7f8aa20034ce338.png";